import { render } from "./PageNotFound.vue?vue&type=template&id=699803c2"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/PageNotFound.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "699803c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('699803c2', __exports__)) {
    api.reload('699803c2', __exports__)
  }
  
  module.hot.accept("./PageNotFound.vue?vue&type=template&id=699803c2", () => {
    api.rerender('699803c2', render)
  })

}


export default __exports__